var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"oct-form__row",class:{
    'oct-form__row--nowrap': _vm.nowrap,
    'oct-form__row--column': _vm.column 
  }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }